import { IconPropsType } from '..';

export const CalendarIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="15"
    height="14"
    viewBox="0 0 15 14"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M4.18369 5.9734H5.44369V7.2334H4.18369V5.9734ZM6.70369 5.9734H7.96369V7.2334H6.70369V5.9734ZM9.22369 5.9734H10.4837V7.2334H9.22369V5.9734ZM4.18369 8.4934H5.44369V9.7534H4.18369V8.4934ZM6.70369 8.4934H7.96369V9.7534H6.70369V8.4934ZM9.22369 8.4934H10.4837V9.7534H9.22369V8.4934ZM11.7437 2.1934V0.933395H10.4837V2.1934H9.22369V0.933395H7.96369V2.1934H6.70369V0.933395H5.44369V2.1934H4.18369V0.933395H2.92369V2.1934H1.03369V12.9034H13.6337V2.1934H11.7437ZM12.3737 11.6434H2.29369V3.4534H2.92369V4.0834H4.18369V3.4534H5.44369V4.0834H6.70369V3.4534H7.96369V4.0834H9.22369V3.4534H10.4837V4.0834H11.7437V3.4534H12.3737V11.6434Z" />
  </svg>
);
